import { getErrorDetails } from '../../utils/errorUtils';

export function getDialogDetailsFromError(error: unknown): string[] | undefined {
    const errorDetails = error instanceof Error ? getErrorDetails(error) : undefined;
    return errorDetails ? errorDetails.details : undefined;
}
